import paymentsConst from './../../../constants/payments.constant';

export default function PaymentFactory(
    $filter,
    tripOptionsService,
    tripUtils,
    cultureService,
    l10nService
) {
    'ngInject';

    const CREDIT_CARD = 'Credit Card';

    const groupPattern = {
        visa: /(\w{1,4})(\w{1,4})?(\w{1,4})?(\w{1,4})?/,
        amEx: /(\w{1,4})(\w{1,6})?(\w{1,5})?/,
        zipCode: /^[A-Za-z0-9 ]+$/,
        usZipCode: /^\d+$/,
        strictExpediaZipCode: /^.{5,10}$/,
        strictExpediaUsZipCode: /^\d{5}$/,
        separator: /\//g,
    };

    return {
        groupPattern,
        detectSelectedCard,
        PrepareFormData: prepareFormData,
        setPaymentOptions,
        setCreditCardTypes,
        isUserHasOwnCard,
        detectCardType,
        GetCardCaption: getCardCaption,
        GetCardTypeCaption: getCardTypeCaption,
        groupByPattern,
        makeChunks,
        lodashFindConverter,
        buildPaymentErrors,
        prepareCountry,
    };


            function detectCardType(cardTypeId, paymentMethod) {
                let type = '';
                if (paymentMethod === paymentsConst.PaymentMethods.invoice) {
                    type = null;
                } else {
                    switch (cardTypeId) {
                        case paymentsConst.CardTypes.visaDebit:
                        case paymentsConst.CardTypes.visaCredit:
                            type = 'Visa';
                            break;
                        case paymentsConst.CardTypes.masterCardCredit:
                        case paymentsConst.CardTypes.masterCardDebit:
                            type = 'MasterCard';
                            break;
                        case paymentsConst.CardTypes.americanExpress:
                            type = 'American Express';
                            break;
                        default:
                            break;
                    }
                }
                return type;
            }

            function detectSelectedCard(collection, selectedCard) {
                const source = selectedCard.Id
                    ? {cardId: selectedCard.Id}
                    : {cardTypeId: selectedCard.CreditCardType, paymentMethod: paymentsConst.PaymentMethods.cardCredit};

                return _.findWhere(collection, source);
            }

            function setPaymentOptions(payment, isOfflineTrip) {
                let paymentOptions = [];

                if (isOfflineTrip && payment.customerCards()) {
                    paymentOptions.push({
                        name: CREDIT_CARD,
                        ShowSmallCreditCardForm: false,
                        paymentMethod: paymentsConst.PaymentMethods.cardCredit,
                    });
                    return paymentOptions;
                }

                const types = (payment.ktCards() || payment.customerCards()) ? payment.creditCardTypes : [];

                /**
                 * Set "Invoice" value to cards dropdown list
                 */
                if (payment.invoice()) {
                    paymentOptions.push({
                        name: l10nService.localize('Invoice'),
                        paymentMethod: paymentsConst.PaymentMethods.invoice,
                        formData: {},
                    });
                }

                /**
                 * Add "exciting cards" to dropdown list
                 */
                if (payment.customerCards()) {
                    paymentOptions = paymentOptions.concat(
                        _.map(payment.creditCards, function(card) {
                            return {
                                name: getCardCaption(card, types),
                                paymentMethod: paymentsConst.PaymentMethods.cardType,
                                cardTypeId: card.Type,
                                cardId: card.Id,
                                formData: prepareFormData(card),
                            };
                        })
                    );
                }

                /**
                 * Add "templates for new cards" to dropdown list
                 */
                paymentOptions = paymentOptions.concat(
                    _.map(types, function(card) {
                        return {
                            name: getCardTypeCaption(card),
                            paymentMethod: paymentsConst.PaymentMethods.cardCredit,
                            cardTypeId: card.Id,
                            formData: {},
                        };
                    })
                );

                /**
                 * Set "default" value to cards dropdown list
                 */
                if (!(paymentOptions.length === 1 && payment.invoice())) {
                    paymentOptions.unshift({
                        name: '---',
                        paymentMethod: null,
                        formData: {},
                    });
                }

                /**
                 * Init "paymentOptions"
                 * @type {Array.<T>}
                 */
                return paymentOptions;
            }

            function setCreditCardTypes(payment) {
                let creditCard = [];

                creditCard = creditCard.concat(
                    _.map(payment.creditCards, function(card) {
                        return {
                            name: getCardCaption(card, payment.creditCardTypes),
                            paymentMethod: paymentsConst.PaymentMethods.cardType,
                            cardTypeId: card.Type,
                            cardId: card.Id,
                            formData: prepareFormData(card),
                        };
                    })
                );

                /**
                 * Add Card Types to dropdown list
                 */
                creditCard = creditCard.concat(
                    _.map(payment.creditCardTypes, function(card) {
                        return {
                            name: card.Name,
                            cardTypeId: card.Id,
                            formData: {},
                        };
                    })
                );

                /**
                 * Set "default" card type
                 */
                if (creditCard.length) {
                    creditCard.unshift({
                        name: '---',
                        cardTypeId: null,
                    });
                }

                return creditCard;
            }

            function prepareFormData(card) {
                card.expires = {
                    month: _.padLeft(card.ExpiryMonth, 2, '0'),
                    year: _.padLeft(card.ExpiryYear, 2, '0'),
                };

                card.issued = (card.IssueMonth && card.IssueYear)
                    ? {
                    month: _.padLeft(card.IssueMonth, 2, '0'),
                    year: _.padLeft(card.IssueYear, 2, '0'),
                }
                    : '';
                prepareCountry(card);
                return card;
            }

            function prepareCountry(card) {
                const countries = tripOptionsService.getCountries().slice();

                card.country = {
                    value: card.CountryCode,
                    text: _.result(_.findWhere(countries, {value: card.CountryCode}), 'text'),
                };
            }

            function isUserHasOwnCard(creditCards) {
                return _.result(_.findWhere(creditCards, {HolderType: paymentsConst.CardHolderType.user}), 'Id');
            }

            function groupByPattern(num, pattern) {
                return (num.match(pattern) || []).slice(1);
            }

            function makeChunks(newValue, step) {
                return chunk(newValue.replace(groupPattern.separator, '').split(''), step).map(function(elem) {
                    return elem.join('');
                });
            }

            function getCardCaption(card, cardTypes) {
                const pieces = [];
                const number = card.Number ? card.Number.substr(-4) : card.LastFourDigits;
                const cardType = _.findWhere(cardTypes, {Id: card.Type});
                let charges = '';

                if (card.Description) {
                    pieces.push(card.Description);
                }

                if (cardType) {
                    pieces.push(cardType.Name);

                    charges = getCardTypeCaption(cardType, number);

                    pieces.push(charges);
                }


                return pieces.join(' - ');
            }

            function getCardTypeCaption(card, number) {
                let caption = number || card.Name;
                let amount;
                let currencyCode;

                if (card.Price && card.Price.Amount) {
                    amount = $filter('number')(card.Price.Amount, 2);
                    currencyCode = cultureService.getCurrencySign(card.Price.CurrencyCode);

                    caption += ' (+ ' + currencyCode + amount + ')';
                }

                return caption;
            }

            function lodashFindConverter(item) {
                if (_.isObject(item)) {
                    return [item];
                }
                return item || [];
            }

            function chunk(collection, chunkSize) {
                if (!collection || _.isNaN(parseInt(chunkSize, 10))) {
                    return [];
                }
                return _.toArray(_.groupBy(collection, function(iterator, index) {
                    return Math.floor(index / parseInt(chunkSize, 10));
                }));
            }

            function buildPaymentErrors(payments, tripDetail) {
                const paymentErrors = [];
                if (_.isEmpty(payments)) {
                    return paymentErrors;
                }

                _.each(payments, function(payment, tripItemId) {
                    const type = getTripItemType(tripItemId, tripDetail);
                    const title = getTripItemTitle(tripItemId, tripDetail);

                    paymentErrors.push({
                        type,
                        title,
                        payment: (payment.length) ? payment.join(', ') : l10nService.localize('not specified'),
                    });
                });

                return paymentErrors;
            }

            function getTripItemType(itemId, tripDetail) {
                let type;

                type = (_.find(tripUtils.getFlights(tripDetail), {SearchFlightRecommendationId: itemId}))
                    ? l10nService.localize('Flight')
                    : null;

                type = (!type && _.find(tripUtils.getHotels(tripDetail), {SearchHotelId: itemId}))
                    ? l10nService.localize('Hotel')
                    : type;

                type = (!type && _.find(tripUtils.getRails(tripDetail), {SearchRailId: itemId}))
                    ? l10nService.localize('Train')
                    : type;

                type = (!type && _.find(tripUtils.getCars(tripDetail), {SearchCarId: itemId}))
                    ? l10nService.localize('Car')
                    : type;
                return type;
            }

            function getTripItemTitle(itemId, tripDetail) {
                let itemData = _.find(tripUtils.getFlights(tripDetail), {SearchFlightRecommendationId: itemId});

                if (itemData) {
                    let flightTitle = '';

                    _.each(itemData.FlightGroups, function(group) {
                        _.each(group.Flights, function(flight) {
                            flightTitle += ' ' + flight.MarketingAirline + ', '
                                + flight.DepartureAirport + ' to ' + flight.ArrivalAirport;
                        });
                    });
                    return flightTitle;
                }

                itemData = _.find(tripUtils.getHotels(tripDetail), {SearchHotelId: itemId});
                if (itemData) {
                    return itemData.Name + ', ' + itemData.City;
                }

                itemData = _.find(tripUtils.getCars(tripDetail), {SearchCarId: itemId});
                if (itemData) {
                    return itemData.ModelName + ', ' + itemData.CarCompany;
                }

                itemData = _.find(tripUtils.getRails(tripDetail), {SearchRailId: itemId});
                if (itemData) {
                    return itemData.ArrivalStation + ' to ' + itemData.DepartureStation;
                }
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/paymentFactory.js